import { TimeSlotsSectionWithAccordion } from '~/components';
import { envConfigSelectors } from '~/selectors';
import { SelectDateTime } from '~/routes';

export const config = {
  Calendar: {
    timeSlotsList: TimeSlotsSectionWithAccordion,
    timeSlotSectionTitle: 'Select a time',
    hideFilters: true,
  },
  SelectDate: {
    componentDecisioner: [
      {
        supports: envConfigSelectors.selectIsNewCalendarEnabled,
        component: SelectDateTime,
      },
    ],
  },
};
